import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, vModelSelect as _vModelSelect, withDirectives as _withDirectives, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("h3", null, "Översikt", -1)
const _hoisted_2 = { class: "row mb-3 mt-3" }
const _hoisted_3 = { class: "col-md-4" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("label", { class: "form-label" }, "Välj utgåva", -1)
const _hoisted_5 = ["value"]
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { class: "row mb-3 mt-3" }
const _hoisted_8 = { class: "col-md-6" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h4", null, "Sidor", -1)
const _hoisted_11 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8" }, "Annonser", -1)
const _hoisted_12 = { class: "col-md-4" }
const _hoisted_13 = { class: "row" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8" }, "Artiklar", -1)
const _hoisted_15 = { class: "col-md-4" }
const _hoisted_16 = { class: "row" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8" }, "Totalt", -1)
const _hoisted_18 = { class: "col-md-4" }
const _hoisted_19 = { class: "row" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "col-md-8" }, "Saknas", -1)
const _hoisted_21 = { class: "col-md-4" }
const _hoisted_22 = { class: "col-md-6" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("h4", null, "Status", -1)
const _hoisted_24 = { class: "col-md-8" }
const _hoisted_25 = { class: "col-md-4" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("hr", null, null, -1)
const _hoisted_27 = { class: "row mb-3 mt-3" }
const _hoisted_28 = { class: "col-md-4" }
const _hoisted_29 = /*#__PURE__*/_createElementVNode("h4", null, "Annonser", -1)
const _hoisted_30 = { class: "table table-sm table-striped" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Annonsör"),
    /*#__PURE__*/_createElementVNode("th", null, "Storlek")
  ])
], -1)
const _hoisted_32 = { class: "col-md-8" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h4", null, "Artiklar", -1)
const _hoisted_34 = { class: "table table-sm table-striped" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", null, "Annonsör"),
    /*#__PURE__*/_createElementVNode("th", null, "Storlek"),
    /*#__PURE__*/_createElementVNode("th", null, "Status"),
    /*#__PURE__*/_createElementVNode("th")
  ])
], -1)
const _hoisted_36 = ["onClick"]
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", { class: "fa fa-edit" }, null, -1)
const _hoisted_38 = [
  _hoisted_37
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _hoisted_4,
        _withDirectives(_createElementVNode("select", {
          class: "form-select form-select-sm",
          onChange: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.editionSelected && _ctx.editionSelected(...args))),
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.selectedEdition) = $event))
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.editions, (edition, index) => {
            return (_openBlock(), _createElementBlock("option", {
              value: edition.editionId,
              key: index
            }, _toDisplayString(edition.editionName), 9, _hoisted_5))
          }), 128))
        ], 544), [
          [_vModelSelect, _ctx.state.selectedEdition]
        ])
      ])
    ]),
    (_ctx.state.editionOverview)
      ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _createElementVNode("div", _hoisted_9, [
                _hoisted_10,
                _hoisted_11,
                _createElementVNode("div", _hoisted_12, _toDisplayString(_ctx.state.editionOverview.advertisementSpace), 1)
              ]),
              _createElementVNode("div", _hoisted_13, [
                _hoisted_14,
                _createElementVNode("div", _hoisted_15, _toDisplayString(_ctx.state.editionOverview.contentSpace), 1)
              ]),
              _createElementVNode("div", _hoisted_16, [
                _hoisted_17,
                _createElementVNode("div", _hoisted_18, _toDisplayString(_ctx.state.editionOverview.advertisementSpace +
                _ctx.state.editionOverview.contentSpace), 1)
              ]),
              _createElementVNode("div", _hoisted_19, [
                _hoisted_20,
                _createElementVNode("div", _hoisted_21, _toDisplayString(_ctx.state.editionOverview.editionPages - (_ctx.state.editionOverview.advertisementSpace +
                _ctx.state.editionOverview.contentSpace)), 1)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.editionOverview.statuses, (value, key, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "row",
                  key: `${key}-${index}`
                }, [
                  _createElementVNode("div", _hoisted_24, _toDisplayString(key), 1),
                  _createElementVNode("div", _hoisted_25, _toDisplayString(value), 1)
                ]))
              }), 128))
            ])
          ]),
          _hoisted_26,
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _hoisted_29,
              _createElementVNode("table", _hoisted_30, [
                _hoisted_31,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.editionOverview.advertisements, (ad, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(ad.advertiser), 1),
                      _createElementVNode("td", null, _toDisplayString(ad.size), 1)
                    ]))
                  }), 128))
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("table", _hoisted_34, [
                _hoisted_35,
                _createElementVNode("tbody", null, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.state.editionOverview.contents, (content, index) => {
                    return (_openBlock(), _createElementBlock("tr", { key: index }, [
                      _createElementVNode("td", null, _toDisplayString(content.title), 1),
                      _createElementVNode("td", null, _toDisplayString(content.size), 1),
                      _createElementVNode("td", null, _toDisplayString(content.status), 1),
                      _createElementVNode("td", null, [
                        _createElementVNode("button", {
                          onClick: ($event: any) => (_ctx.editContent(content.contentId)),
                          class: "btn btn-sm btn-primary",
                          title: "Ändra innehåll"
                        }, _hoisted_38, 8, _hoisted_36)
                      ])
                    ]))
                  }), 128))
                ])
              ])
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}